import styled from '@emotion/styled';
import type { DialogProps } from '@mui/material';
import { DialogTitle, IconButton, Dialog as MuiDialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type Props = DialogProps & {
  title: string;
  closeButton?: boolean;
};

const Title = styled(DialogTitle)`
  &[data-withclose='true'] {
    display: grid;
    grid-template-columns: auto 32px;
  }
`;

const Dialog = ({
  open,
  title,
  children,
  maxWidth = 'sm',
  fullWidth = true,
  closeButton,
  ...props
}: Props) => {
  const handleClose =
    props.onClose ??
    ((_event: unknown, _reason: 'backdropClick' | 'escapeKeyDown') => {});

  return (
    <MuiDialog
      open={open}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      {...props}
      slotProps={{
        paper: { sx: { borderRadius: '8px' } },
      }}
    >
      <Title data-withclose={closeButton}>
        {title}
        {props.onClose !== undefined && closeButton && (
          <IconButton
            size='small'
            onClick={(e) => handleClose(e, 'escapeKeyDown')}
            sx={{ maxHeight: '32px' }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Title>
      {children}
    </MuiDialog>
  );
};

export default Dialog;
